import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommonLayout from "../../layouts/CommonLayout";
import { getEvent } from "../../../api/EventApi";

const EventPage = () => {
    const { eventId } = useParams();
    const [event, setEvent] = useState(null);

    useEffect(() => {
        getEvent(eventId)
            .then((data) => setEvent(data))
            .catch((err) => console.error(err));
    }, [eventId]);

    if (!event) return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-md">로딩 중...</div>
        </div>
    );

    return (
        <CommonLayout title="이벤트">
            <div className="p-4 space-y-4">
                <h1 className="text-xl font-semibold">{event.title}</h1>
                <p className="text-sm text-gray-500">{new Date(event.createdAt).toLocaleDateString('ko-KR')}</p>

                {/* 이미지 URL이 있는 경우에만 렌더링 */}
                {event.imageUrl && (
                    <img
                        src={event.imageUrl}
                        alt="이벤트 이미지"
                        className="w-full"
                    />
                )}

                <hr />
                <div className="text-base whitespace-pre-wrap">{event.content}</div>
            </div>
        </CommonLayout>
    );
};

export default EventPage;
